/**
 * Wishlist Badge2 Metafield Display
 * Bu script wishlist sayfasında ürün fiyatlarının altına custom.badge2 metafield bilgisini ekler
 */

(function() {
  'use strict';

  // LocalStorage key for inventory cache
  const INVENTORY_CACHE_KEY = 'wishlist_inventory_cache';
  const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 dakika

  // Inventory cache'i localStorage'dan al
  function getInventoryCache() {
    try {
      const cached = localStorage.getItem(INVENTORY_CACHE_KEY);
      if (cached) {
        const data = JSON.parse(cached);
        // Cache süresi dolmuşsa temizle
        if (Date.now() - data.timestamp > CACHE_EXPIRY_MS) {
          localStorage.removeItem(INVENTORY_CACHE_KEY);
          return {};
        }
        return data.inventory || {};
      }
    } catch (e) {}
    return {};
  }

  // Inventory cache'e kaydet
  function saveInventoryCache(handle, inventoryMap) {
    try {
      const cache = getInventoryCache();
      cache[handle] = inventoryMap;
      localStorage.setItem(INVENTORY_CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        inventory: cache
      }));
    } catch (e) {}
  }

  // Sayfa yüklendikten sonra çalış
  function initWishlistMetafields() {
    // Wishlist sayfasında olup olmadığını kontrol et
    if (!window.location.pathname.includes('/apps/wishlist')) {
      return;
    }

    // Wishlist ürün kartlarının yüklenmesini bekle
    const checkInterval = setInterval(function() {
      const wishlistCards = document.querySelectorAll('wishlist-product-card');

      if (wishlistCards.length > 0) {
        clearInterval(checkInterval);
        processWishlistCards();

        // Yeni ürünler eklenirse tekrar işle (MutationObserver ile)
        observeWishlistChanges();
      }
    }, 500);

    // 10 saniye sonra interval'i durdur
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 10000);
  }

  // Wishlist kartlarını işle
  function processWishlistCards() {
    const wishlistCards = document.querySelectorAll('wishlist-product-card');
    const inventoryCache = getInventoryCache();

    wishlistCards.forEach(function(card) {
      // Zaten işlenmiş mi kontrol et
      if (card.dataset.metafieldProcessed === 'true') {
        return;
      }

      // İşlenmiş olarak işaretle
      card.dataset.metafieldProcessed = 'true';

      // Ürün linkinden handle bilgisini al
      const productLink = card.querySelector('.wk-text-link');
      if (!productLink) return;

      const href = productLink.getAttribute('href');
      if (!href) return;

      // Handle'ı URL'den çıkar
      const match = href.match(/\/products\/([^?#]+)/);
      if (!match) return;

      const productHandle = match[1];

      // ÖNCE: Cache'den inventory bilgisini hemen uygula (dil değişimi için)
      if (inventoryCache[productHandle]) {
        const cachedInvMap = inventoryCache[productHandle];
        card.dataset.inventoryMap = JSON.stringify(cachedInvMap);

        // Mevcut variant için inventory'yi de set et
        const variantInput = card.querySelector('input[name="id"]');
        if (variantInput && cachedInvMap[variantInput.value]) {
          card.dataset.inventory = cachedInvMap[variantInput.value];
          card.dataset.variantInventory = cachedInvMap[variantInput.value];
        }
        console.log('🛒 Wishlist: Inventory loaded from cache for', productHandle);
      }

      // Metafield bilgisini al ve ekle (bu da inventory'yi güncelleyecek)
      fetchAndDisplayMetafield(card, productHandle);
    });
  }

  // Ürün metafield bilgisini al ve göster
  function fetchAndDisplayMetafield(card, productHandle) {
    // Önce locale bilgisini al
    const locale = document.documentElement.lang || 'ar';
    const pathPrefix = locale === 'ar' ? '' : '/' + locale;

    // Ürün sayfasının tamamını fetch et
    const productPageUrl = `${pathPrefix}/products/${productHandle}`;

    fetch(productPageUrl)
      .then(response => response.text())
      .then(html => {
        // HTML'i parse et
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        let badge2Value = '';

        // .font-size-strong class'ına sahip elementleri ara
        const fontSizeStrongs = doc.querySelectorAll('.font-size-strong');

        if (fontSizeStrongs.length > 0) {
          // İkinci element badge2'dir (birinci badge1)
          if (fontSizeStrongs.length >= 2) {
            badge2Value = fontSizeStrongs[1].textContent.trim();
          } else if (fontSizeStrongs.length === 1) {
            // Tek element varsa onu kullan
            badge2Value = fontSizeStrongs[0].textContent.trim();
          }
        }

        // Eğer bulamadıysak, product__title içindeki strong'ları ara
        if (!badge2Value) {
          const productTitle = doc.querySelector('.product__title');
          if (productTitle) {
            const strongs = productTitle.querySelectorAll('strong');

            if (strongs.length >= 2) {
              badge2Value = strongs[1].textContent.trim();
            } else if (strongs.length === 1) {
              badge2Value = strongs[0].textContent.trim();
            }
          }
        }

        // Badge2 değeri varsa wishlist kartına ekle
        if (badge2Value) {
          displayBadge2(card, badge2Value);
        }

        // STOK BİLGİSİNİ AL VE CARD'A EKLE (wishlist-stock-control için)
        // Product sayfasından inventory bilgisini çıkarmaya çalış
        extractInventoryFromProductPage(card, doc, productHandle);
      })
      .catch(function(error) {
        // Hata durumunda sessizce devam et
        console.error('Wishlist badge2 error:', error);
      });
  }

  // Product sayfasından inventory bilgisini çıkar
  function extractInventoryFromProductPage(card, doc, productHandle) {
    // Wishlist card'ındaki variant input'unu bul
    const variantInput = card.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? variantInput.value : null;

    // 1. ÖNCE: Gizli JSON inventory verisini dene (main-product.liquid tarafından render edilir)
    const inventoryScript = doc.querySelector('.wishlist-inventory-data');
    if (inventoryScript) {
      try {
        const inventoryData = JSON.parse(inventoryScript.textContent);
        const inventoryMap = {};
        let hasInventory = false;

        for (const [variantId, data] of Object.entries(inventoryData)) {
          if (data.inventory_management === 'shopify') {
            inventoryMap[variantId] = data.inventory_quantity;
            hasInventory = true;
          } else {
            // Stok takibi yoksa sınırsız kabul et
            inventoryMap[variantId] = 999999;
          }
        }

        if (hasInventory) {
          card.dataset.inventoryMap = JSON.stringify(inventoryMap);
          if (currentVariantId && inventoryMap[currentVariantId] !== undefined) {
            card.dataset.inventory = inventoryMap[currentVariantId];
            card.dataset.variantInventory = inventoryMap[currentVariantId];
          }
          saveInventoryCache(productHandle, inventoryMap);
          console.log('🛒 Wishlist: Inventory from hidden JSON for', productHandle, inventoryMap);
          return; // Güvenilir kaynak bulundu
        }
      } catch (e) {
        console.warn('🛒 Wishlist: Could not parse hidden inventory JSON:', e);
      }
    }

    // 2. .product__inventory elementinden dene
    const inventoryElement = doc.querySelector('.product__inventory');
    if (inventoryElement) {
      // "Only X left!" veya "Sadece X adet kaldı" gibi bir metin olabilir
      const inventoryText = inventoryElement.textContent.trim();
      const numberMatch = inventoryText.match(/(\d+)/);
      if (numberMatch) {
        const inventoryQty = parseInt(numberMatch[1], 10);
        if (!isNaN(inventoryQty)) {
          card.dataset.inventory = inventoryQty;
          card.dataset.variantInventory = inventoryQty;
          console.log('🛒 Wishlist: Inventory from product page:', productHandle, '=', inventoryQty);

          // inventoryMap da oluştur (tek variant için)
          if (currentVariantId) {
            const invMap = {};
            invMap[currentVariantId] = inventoryQty;
            card.dataset.inventoryMap = JSON.stringify(invMap);
            // Cache'e kaydet (dil değişimi için)
            saveInventoryCache(productHandle, invMap);
          }
          return; // Bulduysak başka denemeye gerek yok
        }
      }
    }

    // 3. Product sayfasından bulamadıysak, product JSON endpoint'ini dene
    fetchInventoryFromProductJson(card, productHandle);
  }

  // Product JSON endpoint'inden stok bilgisi al
  function fetchInventoryFromProductJson(card, productHandle) {
    // Önce locale bilgisini al
    const locale = document.documentElement.lang || 'ar';
    const pathPrefix = locale === 'ar' ? '' : '/' + locale;

    // Product JSON endpoint'ini kullan
    const productJsonUrl = `${pathPrefix}/products/${productHandle}.js`;

    fetch(productJsonUrl)
      .then(response => response.json())
      .then(productData => {
        if (!productData || !productData.variants) {
          console.log('🛒 Wishlist: No variants found for', productHandle);
          // Search fallback'e geç
          fetchInventoryFromSearchFallback(card, productHandle);
          return;
        }

        // Wishlist card'ındaki variant input'unu bul
        const variantInput = card.querySelector('input[name="id"]');
        const currentVariantId = variantInput ? variantInput.value : null;

        // Tüm variant inventory'lerini sakla
        const inventoryMap = {};
        let currentVariantInventory = null;
        let hasAnyInventory = false;

        productData.variants.forEach(variant => {
          // Sadece stok takibi yapılan ve stok yokken satışa izin verilmeyen ürünler için
          if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
            // inventory_quantity varsa kullan
            let inventoryQty = variant.inventory_quantity;
            if (typeof inventoryQty === 'number') {
              hasAnyInventory = true;
              inventoryMap[String(variant.id)] = inventoryQty;

              // Mevcut variant'ın inventory'sini kaydet
              if (currentVariantId && String(variant.id) === String(currentVariantId)) {
                currentVariantInventory = inventoryQty;
              }
            } else {
              // inventory_quantity yoksa, available durumuna göre: true=999999, false=0
              inventoryMap[String(variant.id)] = variant.available ? 999999 : 0;
            }
          } else {
            // Stok takibi yoksa sınırsız kabul et
            inventoryMap[String(variant.id)] = 999999;
          }
        });

        // inventory_quantity döndü mü kontrol et
        if (!hasAnyInventory) {
          console.log('🛒 Wishlist: Product JSON has no inventory_quantity, trying search fallback');
          fetchInventoryFromSearchFallback(card, productHandle);
          return;
        }

        // Inventory map'i card'a ekle
        if (Object.keys(inventoryMap).length > 0) {
          card.dataset.inventoryMap = JSON.stringify(inventoryMap);
          // Cache'e kaydet (dil değişimi için)
          saveInventoryCache(productHandle, inventoryMap);
          console.log('🛒 Wishlist: Inventory map from JSON for', productHandle, inventoryMap);
        }

        // Mevcut variant'ın inventory'sini de ekle
        if (currentVariantInventory !== null) {
          card.dataset.inventory = currentVariantInventory;
          card.dataset.variantInventory = currentVariantInventory;
          console.log('🛒 Wishlist: Current variant inventory set:', currentVariantId, '=', currentVariantInventory);
        }
      })
      .catch(function(error) {
        console.error('🛒 Wishlist: Product JSON fetch error:', error);
        // JSON endpoint çalışmazsa, search sayfasından dene (fallback)
        fetchInventoryFromSearchFallback(card, productHandle);
      });
  }

  // Fallback: Search sayfasından stok bilgisi al
  function fetchInventoryFromSearchFallback(card, productHandle) {
    const locale = document.documentElement.lang || 'ar';
    const pathPrefix = locale === 'ar' ? '' : '/' + locale;
    const searchUrl = `${pathPrefix}/search?q=${encodeURIComponent(productHandle)}&type=product&options[prefix]=last`;

    fetch(searchUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // card-product içindeki data-inventory attribute'larından stok bilgisini al
        // Hem a hem de button elementlerini kontrol et
        const variantItems = doc.querySelectorAll('[data-variant-id][data-inventory]');
        if (variantItems.length > 0) {
          const variantInput = card.querySelector('input[name="id"]');
          const currentVariantId = variantInput ? variantInput.value : null;

          const inventoryMap = {};
          variantItems.forEach(item => {
            if (item.dataset.variantId && item.dataset.inventory) {
              inventoryMap[item.dataset.variantId] = item.dataset.inventory;

              // Eşleşen variant'ı card'a ekle
              if (currentVariantId && item.dataset.variantId === currentVariantId) {
                card.dataset.inventory = item.dataset.inventory;
                card.dataset.variantInventory = item.dataset.inventory;
                console.log('🛒 Wishlist (fallback): Inventory set for variant', currentVariantId, ':', item.dataset.inventory);
              }
            }
          });

          if (Object.keys(inventoryMap).length > 0) {
            card.dataset.inventoryMap = JSON.stringify(inventoryMap);
            // Cache'e kaydet (dil değişimi için)
            saveInventoryCache(productHandle, inventoryMap);
            console.log('🛒 Wishlist (fallback): Inventory map set for', productHandle);
          }
        }
      })
      .catch(function(error) {
        console.error('🛒 Wishlist (fallback): Search fetch error:', error);
      });
  }

  // Badge2 bilgisini wishlist kartında göster
  function displayBadge2(card, badge2Value) {
    // Fiyat elementini bul
    const priceElement = card.querySelector('.wk-price');
    if (!priceElement) return;

    // Badge2 zaten eklenmişse tekrar ekleme
    if (card.querySelector('.wishlist-badge2')) return;

    // Badge2 elementi oluştur
    const badge2Container = document.createElement('div');
    badge2Container.className = 'wishlist-badge2';

    const badge2Text = document.createElement('strong');
    badge2Text.textContent = badge2Value;

    badge2Container.appendChild(badge2Text);

    // Fiyatın altına ekle
    priceElement.parentNode.insertBefore(badge2Container, priceElement.nextSibling);
  }

  // Wishlist'teki değişiklikleri gözlemle
  function observeWishlistChanges() {
    const wishlistGrid = document.querySelector('wishlist-page .wk-grid');
    if (!wishlistGrid) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Yeni ürün kartları eklendiyse işle
          setTimeout(processWishlistCards, 100);
        }
      });
    });

    observer.observe(wishlistGrid, {
      childList: true,
      subtree: true
    });
  }

  // Sayfa yüklendikten sonra başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistMetafields);
  } else {
    initWishlistMetafields();
  }

  // URL değişikliklerini de dinle (SPA-style navigation için)
  let lastUrl = location.href;
  new MutationObserver(function() {
    const currentUrl = location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      initWishlistMetafields();
    }
  }).observe(document, { subtree: true, childList: true });

})();